import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { cx } from '@/lib/cx';
import { Contador } from '@/ui/components/contador';
import { Skeleton } from '@/ui/primitives/skeleton';

import { useResumoPendenciasDoMes } from './api';

const NIVEIS = [
  { chave: 'ALTA', rotulo: 'alta', cor: 'text-perigo' },
  { chave: 'MEDIA', rotulo: 'média', cor: 'text-alerta' },
  { chave: 'BAIXA', rotulo: 'baixa', cor: 'text-texto-suave' },
] as const;

/** Pendências do mês por prioridade, com atalho para o painel completo. */
export function PainelPendencias({ empresaIds }: { empresaIds: readonly string[] }) {
  const resumo = useResumoPendenciasDoMes(empresaIds);
  return (
    <section
      aria-label="Pendências do mês"
      className="grid content-start gap-3 rounded-painel border border-borda bg-superficie p-5"
    >
      <header className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Pendências do mês</h2>
        <Link
          to="/pendencias"
          className="group inline-flex items-center gap-1 text-sm text-marca hover:underline"
        >
          Ver pendências
          <ArrowRight
            className="size-3.5 transition-transform duration-[var(--duracao-rapida)] group-hover:translate-x-0.5"
            aria-hidden
          />
        </Link>
      </header>
      {resumo.isPending && <Skeleton className="h-16" />}
      {resumo.isError && (
        <p className="text-sm text-texto-fraco">Não foi possível carregar as pendências agora.</p>
      )}
      {resumo.data && (
        <dl className="grid grid-cols-3 gap-3">
          {NIVEIS.map((n) => (
            <div key={n.chave} className="flex flex-col-reverse gap-0.5">
              <dt className="text-sm text-texto-suave">{n.rotulo}</dt>
              <dd className={cx('text-3xl font-semibold tabular', n.cor)}>
                <Contador valor={resumo.data.porPrioridade[n.chave]} />
              </dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
}
